import api from "../../../../../../../../utils/api"

export const updateCaseInfo = async ({deadline, priority, handler, caseId}) => {
    let {data} = await api.patch('/report-cases/'+caseId+'/manage', {deadline, priority, handler})
    return data
}